import React, { useState } from 'react';
import AppButton from '../../../../common/Forms/AppButton/AppButton';
import NewHotelSelector from '../../../../common/HotelSelector_new/NewHotelSelector';
import styles from './HotelsEditor.styles';
import LanguageSelectorMultiple from 'Components/common/LanguageSelectorNew/LanguageSelectorMultiple';
import { useHotelLangSelection } from 'context/HotelLangSelectionContext';

export default function HotelsEditor({
  currentHotel,
  setFields,
  setAdviceChanges,
  availableLanguages,
  label,
  labelSave,
  disabled = false,
  hidden = false,
  alignItems = 'flex-end',
  updateSenderRecipients,
}) {
  if (hidden) return '';
  const [selectedHotels, setSelectedHotels] = useState([]);
  const { selectedLanguages } = useHotelLangSelection();

  return (
    <div style={styles.container}>
      <div style={styles.title}>
        <b>{label}</b>
      </div>
      <div style={{ ...styles.hotelSelectorContainer, alignItems }}>
        <NewHotelSelector
          enableAllHotels={false}
          mode="multiple"
          onHotelSelected={setSelectedHotels}
          autoSelect={true}
          excludeHotels={[currentHotel?.key]}
          disabled={disabled}
        />
      </div>
      {!updateSenderRecipients ? (
        <LanguageSelectorMultiple
          isLoading={false}
          customStyles={{ ...styles.languageSelectorContainer, alignItems }}
          availableLanguages={availableLanguages}
        />
      ) : null}

      <AppButton
        text={labelSave}
        action={() => {
          const selectedLanguagesCode = [];
          for (const lang of Object.values(selectedLanguages)) {
            selectedLanguagesCode.push(lang.code);
          }
          setFields(
            false,
            updateSenderRecipients,
            selectedHotels,
            updateSenderRecipients ? [] : selectedLanguagesCode
          );
          setAdviceChanges(true);
        }}
        small
        style={styles.buttonStyle}
        disabled={selectedHotels === 0 || disabled}
      />
    </div>
  );
}
